import { useMultipleSelection, useSelect } from "downshift";
import React from "react";

export const Filter = ({ label, items, initialSelectedItems, onChange }) => {
    const {
        getSelectedItemProps,
        getDropdownProps,
        addSelectedItem,
        removeSelectedItem,
        selectedItems
    } = useMultipleSelection({
        initialSelectedItems: initialSelectedItems || [], onSelectedItemsChange: ({ selectedItems }) => {
            onChange(selectedItems)
        }
    })

    // useEffect(() => {
    //     setSelectedItems(initialSelectedItems)
    // }, [initialSelectedItems, setSelectedItems]);

    const getFilteredItems = () =>
        items.filter(item => selectedItems.indexOf(item) < 0)
    const {
        isOpen,
        selectedItem,
        getToggleButtonProps,
        getLabelProps,
        getMenuProps,
        highlightedIndex,
        getItemProps,
    } = useSelect({
        selectedItem: null,
        defaultHighlightedIndex: 0, // after selection, highlight the first item.
        items: getFilteredItems(),
        stateReducer: (state, actionAndChanges) => {
            const { changes, type } = actionAndChanges
            switch (type) {
                case useSelect.stateChangeTypes.MenuKeyDownEnter:
                case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
                case useSelect.stateChangeTypes.ItemClick:
                    return {
                        ...changes,
                        isOpen: true, // keep the menu open after selection.
                    }
            }
            return changes
        },
        onStateChange: ({ type, selectedItem }) => {
            switch (type) {
                case useSelect.stateChangeTypes.MenuKeyDownEnter:
                case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
                case useSelect.stateChangeTypes.ItemClick:
                    if (selectedItem) {
                        addSelectedItem(selectedItem)
                    }
                    break
                default:
                    break
            }
        },
    })

    return (
        <div className="flex flex-row items-center mt-3">
            <label className="w-1/3 paragraph" {...getLabelProps()}>{label}</label>
            <div className="w-2/3 paragraph">
                <div className="relative left-0 right-0">
                    <div className="border border-black flex flex-row items-center relative ">
                        <div className="flex flex-row flex-1 flex-wrap items-center">
                            {selectedItems.length === 0 ? <span className="px-2 py-1 my-1">All</span> : null}
                            {selectedItems.map((selectedItem, index) => (
                                <span
                                    className="px-2 py-1 my-1 l-1 flex flex-row bg-stone-300 rounded-xl ml-1"
                                    key={`selected-item-${index}`}
                                    {...getSelectedItemProps({ selectedItem, index })}
                                >
                                    {selectedItem.label}
                                    <button
                                        className="ml-1"
                                        onClick={e => {
                                            e.stopPropagation()
                                            removeSelectedItem(selectedItem)
                                        }}
                                    >
                                        &#10005;
                                    </button>
                                </span>
                            ))}
                        </div>
                        <div>
                            <button {...getToggleButtonProps(
                                getDropdownProps({ preventKeyAction: isOpen }),
                            )} className="px-3" aria-label={'toggle menu'}>
                                <i className={`fal fa-chevron-up transition-all ${isOpen ? 'rotate-0' : 'rotate-180'}`}></i>
                            </button>
                        </div>
                    </div>
                    <ul style={{
                        padding: 0,
                        marginTop: 0,
                        position: "absolute",
                        // backgroundColor: "white",
                        width: "100%",
                        maxHeight: "20rem"
                    }} {...getMenuProps()} className={"z-10 overflow-y-auto overflow-x-hidden shadow border-x border-b border-black bg-lightoffwhite "+(isOpen ? '' : 'hidden')}>
                        {isOpen && getFilteredItems(items).map((item, index) => (
                            <li
                                className={`p-2 ${highlightedIndex === index ? 'font-bold' : 'font-normal'} ${highlightedIndex === index ? 'bg-stone-300 bg-blend-multiply' : ''}`}
                                key={index}
                                {...getItemProps({ item, index })}
                            >
                                {item.label}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export const FilterCheckbox = ({ label, description, checked, onChange }) => {
    return (
        <div className="flex flex-row items-center my-3">
            <label className="w-1/3 paragraph">{label}</label>
            <label className="w-2/3 inline-flex paragraph items-center my-2">
                <input type="checkbox" className="form-checkbox h-5 w-5 paragraph" defaultChecked={checked} onChange={(event) => onChange(event.target.checked)} /><span className="ml-2">{description}</span>
            </label>
        </div>
    )
}